import { t } from 'i18next';
import { useContext } from 'react';

import DebouncedSearchBox from '~components/Search/DebouncedSearchBox';

import ProjectsQueryContext from '../../ProjectsQueryContext';

export default function Search() {
  const { applySearchQuery } = useContext(ProjectsQueryContext);

  return (
    <DebouncedSearchBox
      onChange={applySearchQuery}
      placeholder={`${t('form_fields.search')}`}
    />
  );
}
